export class ActivityFinishSuccesfully {

    requestId: number;
    activityId: number;
    activityResultIds: number[] = [];
    newFinishDateFact: Date;
    merchantMemberName: string;
    merchantMemberEmail: string;
}